
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  attachedFile: null,
};

const offerLetterSlice = createSlice({
  name: 'offerLetter',
  initialState,
  reducers: {
    setAttachedFile(state, action) {
      state.attachedFile = action.payload;
    },
    clearAttachedFile(state) {
      state.attachedFile = null;
    },
  },
});

export const { setAttachedFile, clearAttachedFile } = offerLetterSlice.actions;
export default offerLetterSlice.reducer;
